import { render } from "./AboutScreen.vue?vue&type=template&id=293e299e"
import script from "./AboutScreen.vue?vue&type=script&lang=js"
export * from "./AboutScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__